module.exports = "<header>\n  <h1>Also consider</h1>\n</header>\n\n<div class=\"alternate-brands-content\">\n  <ng-transclude></ng-transclude>\n</div>\n"